import { compose } from 'redux';
import { connect } from 'react-redux';
import Comments from '../components/Comments';
import onlyIf from '../hocs/onlyIf';
import * as actionCreators from '../actionCreators';
import { getIsCommentingEnabled } from '../selectors/project';
function mapStateToProps(state) {
    return {
        commentCount: state.comment.count,
        notification: state.comment.notification,
        isCommentingEnabled: getIsCommentingEnabled(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onNotificationClick: function () {
            dispatch(actionCreators.hideCommentNotification());
            dispatch(actionCreators.showComments());
            dispatch(actionCreators.setLeaveCommentPopoverCookie());
        },
        onCommentButtonClick: function () {
            dispatch(actionCreators.hideCommentNotification());
            dispatch(actionCreators.showComments());
            dispatch(actionCreators.setLeaveCommentPopoverCookie());
        },
    };
}
var IsCommentingEnabled = function (props) { return props.isCommentingEnabled; };
export default compose(connect(mapStateToProps, mapDispatchToProps), onlyIf(IsCommentingEnabled))(Comments);
